<!-- For Menu -->
<ng-template #MainMenu>
    <div class="innerpage-fullwithbanner">
        <h2 class="bighead">Activity Log</h2>
        <ul class="bread-crumbs">
            <li><a (click)="Validation.refreshPage('')">Home<span>|</span></a></li>
            <li *ngIf="prevPage!=''">
                <a (click)="onBreadCrumbClick();">{{prevPage}}<span>|</span></a>
            </li>
            <li>Activity Log</li>
        </ul>
    </div>
    <div class="section-margin">
        <div class="container container-lg min-heightcontainer">
            <ng-container *ngIf="propertyView;else TemplateAudit"></ng-container>
        </div>
    </div>
</ng-template>
<!-- Menu End -->
<!-- For Property Tab -->
<ng-container *ngIf="propertyView;else MainMenu">
    <ng-container *ngIf="1==2;else TemplateAudit"></ng-container>
</ng-container>
<!-- End Property Tab -->

<ng-template #TemplateAudit>
    <div [ngClass]="{'border-div margin0 view-audit-trail clearfix': currentAccess !== accessFrom.UserDetails}">

        <!--new autit trail starts-->
        <div class="row">
            <h5 *ngIf="propertyAddedByInfo" style="color: #053d5d;font-weight: 600;margin: 0px 0 15px 15px;font-size: 14px;"><span style="font-size: 14px;">Property Created By : </span> {{propertyAddedByInfo}}</h5>
        </div>

        <div class="activitysearch" [ngClass]="{'fiveinputs':propertyView==true}">
          <ul class="clearfix" *ngIf="exchangeId == 0">
            <li *ngIf="!propertyView">
              <div class="textbox-date margin-top-10">
                <!--<label class="form-label">Tenant </label>-->
                <tag-input [ngModel]="tenants" (onTextChange)="tenantSearch($event)" (onAdd)="onAdd($event,'Tenant')" (onRemove)="onRemove($event,'Tenant')" [onlyFromAutocomplete]="true" secondaryPlaceholder="Select a Tenant" placeholder="+ Tenants">
                  <tag-input-dropdown [showDropdownIfEmpty]="true"
                                      [autocompleteItems]="tenantlst">
                  </tag-input-dropdown>
                </tag-input>

              </div>
            </li>
            <li *ngIf="!propertyView">
              <div class="textbox-date margin-top-10">
                <tag-input style="width:220px" [ngModel]="propertyType" (onAdd)="onAdd($event,'Property Type')" (onRemove)="onRemove($event,'Property Type')" [onlyFromAutocomplete]="true" secondaryPlaceholder="Select a Property Type" placeholder="+ Property Type">
                  <tag-input-dropdown [showDropdownIfEmpty]="true"
                                      [autocompleteItems]="propertyTypeLst">
                  </tag-input-dropdown>
                </tag-input>
              </div>
            </li>
            <li *ngIf="!propertyView">
              <div class="textbox-date margin-top-10">
                <tag-input style="width:220px" [ngModel]="subCategory" (onAdd)="onAdd($event,'Subcategory')" (onRemove)="onRemove($event,'Subcategory')" [onlyFromAutocomplete]="true" secondaryPlaceholder="Select a Subcategory" placeholder="+ Subcategory">
                  <tag-input-dropdown [showDropdownIfEmpty]="true"
                                      [autocompleteItems]="subCategoryLst">
                  </tag-input-dropdown>
                </tag-input>
              </div>
            </li>
            <li *ngIf="!propertyView">
              <div class="textbox-date margin-top-10">
                <!--<label class="form-label">Property </label>-->
                <tag-input [ngModel]="properties" (onTextChange)="propertySearch($event)" (onAdd)="onAdd($event,'Property')" (onRemove)="onRemove($event,'Property')" [onlyFromAutocomplete]="true" secondaryPlaceholder="Select a Property" placeholder="+ Properties">
                  <tag-input-dropdown [showDropdownIfEmpty]="true"
                                      [autocompleteItems]="propertyLstNew">
                  </tag-input-dropdown>
                </tag-input>
              </div>
            </li>
            <li *ngIf="exchangeId == 0 && IsDisplayUser!=1">
              <div class="textbox-date margin-top-10">
                <!--<label class="form-label">User </label>-->
                <tag-input [ngModel]="users" (onTextChange)="binduserssearch($event)" (onAdd)="onAdd($event,'User')" (onRemove)="onRemove($event,'User')" [onlyFromAutocomplete]="true" secondaryPlaceholder="Select a User" placeholder="+ Users">
                  <tag-input-dropdown [showDropdownIfEmpty]="true"
                                      [autocompleteItems]="userlst">
                  </tag-input-dropdown>
                </tag-input>
              </div>
            </li>
            <li *ngIf="exchangeId == 0&& IsDisplayUser!=1">
              <div class="form-group">
                <label class="form-label">
                  Role
                </label>
                <label class="select">
                  <select class="form-control" [disabled]="currentAccess === accessFrom.UserDetails" [(ngModel)]="userRoleId" (change)="onRoleChange()">
                    <option [ngValue]="0">Select</option>
                    <option [ngValue]="ur.id" *ngFor="let ur of userRoleList">{{ur.name}}</option>
                  </select>
                  <i></i>
                </label>
              </div>
            </li>
            <li *ngIf="exchangeId == 0">
              <div class="form-group dropdown-with-checkbox select-dropdown multiselectdesign multi-check-dropdown ">
                <label class="form-label">
                  Action Type
                </label>
                <div class="btn-group" dropdown [insideClick]="true">
                  <button id="button-basic" dropdownToggle type="button" class="btn btn-primary dropdown-toggle"
                          aria-controls="dropdown-basic">
                    {{selectedText}} <span class="caret"></span>
                  </button>
                  <ul #dropdownState id="dropdown-basic" role="menu" aria-labelledby="button-basic" class="dropdown-menu">
                    <li class="heading" role="heading" *ngFor="let cat of categoryList">
                      {{cat.Category}}
                      <ul class="flex-direction-colum margin-top-10">
                        <li role="menuitem" *ngFor="let sub of cat.SubCategory" class="check-list">
                          <label for="checkbox + {{sub.CategoryId}} + {{sub.SubCategoryId}}" class="custom-checkbox">
                            <input id="checkbox + {{sub.CategoryId}} + {{sub.SubCategoryId}}" [(ngModel)]="sub.SelectedSubCategory" (ngModelChange)="selectSubCategory(sub);changeFilterLabel(sub)" type="checkbox" class="border-checkbox">  <i></i> {{sub.SubCategory}}
                          </label>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </li>
            <li class="date-field">
              <div class="form-group">
                <label class="form-label">Date Range</label>
                <div class="textbox-date">
                  <input class="form-control" [(ngModel)]="dateFromRange" type="text" placeholder="From" placement="bottom right" bsDatepicker>
                  <i class="icofont icofont-ui-calendar icon"></i>
                </div>
              </div>
              <div class="form-group">
                <label class="form-label hide480">&nbsp;</label>
                <div class="textbox-date">
                  <input class="form-control" [(ngModel)]="dateToRange" type="text" placement="bottom right" placeholder="To" bsDatepicker>
                  <i class="icofont icofont-ui-calendar icon"></i>
                </div>
              </div>
            </li>
          </ul>

          <div *ngIf="exchangeId == 0" class="text-right margin-bottom-20">
            <button class="btn-lg btn btn-success" style="margin-top:0;" (click)="search()">Search</button>
            <button class="btn-lg btn-border btn adduserbtn margin-left-10" style="margin-top:0;" (click)="resetSearch();">Reset</button>
            <button *ngIf="!propertyView" class="btn-lg btn-border btn adduserbtn margin-left-10" style="margin-top:0;" (click)="exportToExcell();">Export</button>
          </div>



          <ul class="clearfix" *ngIf="exchangeId > 0">
            <li *ngIf="exchangeId > 0 && isExchangeAudit">
              <div class="form-group dropdown-with-checkbox select-dropdown multiselectdesign multi-check-dropdown ">
                <label class="form-label">
                  Action Type
                </label>
                <div class="btn-group" dropdown [insideClick]="true">
                  <button id="button-basic" dropdownToggle type="button" class="btn btn-primary dropdown-toggle"
                          aria-controls="dropdown-basic">
                    {{selectedText}} <span class="caret"></span>
                  </button>
                  <ul #dropdownState id="dropdown-basic" role="menu" aria-labelledby="button-basic" class="dropdown-menu">
                    <li class="heading" role="heading" *ngFor="let cat of exchangeCategoryList">
                      {{cat.Category}}
                      <ul class="flex-direction-colum margin-top-10">
                        <li role="menuitem" *ngFor="let sub of cat.SubCategory" class="check-list">
                          <label for="checkbox + {{sub.CategoryId}} + {{sub.SubCategoryId}}" class="custom-checkbox">
                            <input id="checkbox + {{sub.CategoryId}} + {{sub.SubCategoryId}}" [(ngModel)]="sub.SelectedSubCategory" (ngModelChange)="selectSubCategory(sub);changeFilterLabel(sub)" type="checkbox" class="border-checkbox">  <i></i> {{sub.SubCategory}}
                          </label>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </li>
            <li *ngIf="exchangeId > 0 && !isExchangeAudit">
              <div class="form-group dropdown-with-checkbox select-dropdown multiselectdesign multi-check-dropdown ">
                <label class="form-label">
                  Action Type
                </label>
                <div class="btn-group" dropdown [insideClick]="true">
                  <button id="button-basic" dropdownToggle type="button" class="btn btn-primary dropdown-toggle"
                          aria-controls="dropdown-basic">
                    {{selectedText}} <span class="caret"></span>
                  </button>
                  <ul #dropdownState id="dropdown-basic" role="menu" aria-labelledby="button-basic" class="dropdown-menu">
                    <li class="heading" role="heading" *ngFor="let cat of exchangeUserCategoryList">
                      {{cat.Category}}
                      <ul class="flex-direction-colum margin-top-10">
                        <li role="menuitem" *ngFor="let sub of cat.SubCategory" class="check-list">
                          <label for="checkbox + {{sub.CategoryId}} + {{sub.SubCategoryId}}" class="custom-checkbox">
                            <input id="checkbox + {{sub.CategoryId}} + {{sub.SubCategoryId}}" [(ngModel)]="sub.SelectedSubCategory" (ngModelChange)="selectSubCategory(sub);changeFilterLabel(sub)" type="checkbox" class="border-checkbox">  <i></i> {{sub.SubCategory}}
                          </label>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </li>
            <li class="date-field1">
              <div class="form-group">
                <label class="form-label">Date Range</label>
                <div class="textbox-date">
                  <input class="form-control" [(ngModel)]="dateFromRange" type="text" placeholder="From" bsDatepicker>
                  <i class="icofont icofont-ui-calendar icon"></i>
                </div>
              </div>
            </li>
            <li class="date-field1">
              <div class="form-group">
                <label class="form-label hide480">&nbsp;</label>
                <div class="textbox-date">
                  <input class="form-control" [(ngModel)]="dateToRange" type="text" placeholder="To" bsDatepicker>
                  <i class="icofont icofont-ui-calendar icon"></i>
                </div>
              </div>
            </li>
            <li class="searchbtns">
              <button class="btn-lg btn btn-success" (click)="search()">Search</button>
              <button class="btn-lg btn-border btn adduserbtn margin-left-10" (click)="resetSearch();">Reset</button>
            </li>

          </ul>
        
          <div class="table-responsive">

            <table class="table basictable row-border hover widthqualtable" datatable [dtOptions]="dtOptions">
              <tbody>
                <tr *ngFor="let item of auditTrailList;let i = index ">
                  <td><p>{{convertUTCDateToLocalDate(item.CreatedOn)| date:'MM/dd/yyyy, h:mm a'}}</p></td>
                  <td>
                    <p>
                      <strong *ngIf="isAdmin || isBroker">
                        <strong *ngIf="!item.IsEmployee && item.UserGuid != null">
                          <a href="javascript:void(0);" routerLink="/registered-user-details/" [queryParams]="{prevroute:'Activity Log',link:router.url,principal:item.UserGuid}">{{item.CreatedBy}}</a>
                        </strong>
                        <strong *ngIf="item.IsEmployee && item.UserGuid != null">
                          <a href="javascript:void(0);" routerLink="/employee-details/" [queryParams]="{prevroute:'Activity Log',link:router.url,user:item.UserGuid}">{{item.CreatedBy}}</a>
                        </strong>
                        <strong *ngIf="item.UserGuid == null">
                          {{item.CreatedBy}}
                        </strong>
                      </strong>
                      <strong *ngIf="!isAdmin && !isBroker">
                        {{item.CreatedBy}}
                      </strong>
                      <span *ngIf="item.ActionId !== 2615 && item.ActionId != 2630">
                        {{item.ShortDescription}}
                      </span>
                      <span *ngIf="item.ModuleTypeId == 320">
                        <span *ngIf="item.ActionId == 2630">
                          <span *ngIf="item.ShortDescription != 'Removed'">
                            <span> Moved </span>
                            <strong>
                              <a href="javascript:void(0);" routerLink="/viewproperty/{{item.Slug ? item.Slug : item.PropertyGuid}}" [queryParams]="{prevroute:previousPageRouteName,link:router.url}">{{item.ObjectName}}</a>
                            </strong>
                            {{item.ShortDescription}}
                          </span>
                          <span *ngIf="item.ShortDescription == 'Removed'">
                            {{item.ShortDescription}}
                            <strong>
                              <a href="javascript:void(0);" routerLink="/viewproperty/{{item.Slug ? item.Slug : item.PropertyGuid}}" [queryParams]="{prevroute:previousPageRouteName,link:router.url}">{{item.ObjectName}}</a>
                            </strong>
                            from 1031 exchange
                          </span>
                        </span>
                      </span>
                      <span *ngIf="item.ActionId === 2615">
                        {{item.ShortDescription}}
                        <ng-container *ngFor="let prop of item.Merge; let i = index">
                          <a (click)="openProperty(prop.PGuid);">{{prop.PId}}</a>
                          <span *ngIf="i+1 < item.Merge.length">, </span>
                        </ng-container>
                        to
                      </span>
                      <!--<span *ngIf="item.ActionId === 2611"> for </span>-->
                      <span *ngIf="item.ActionId === 2610 && item.ModuleTypeId==302 && item.AssociatedUser != null">
                        <strong *ngIf="!item.IsUser">
                          <a href="javascript:void(0);" routerLink="/registered-user-details/" [queryParams]="{prevroute:'Activity Log',link:router.url,principal:item.AssociateUserGUID}">{{item.AssociatedUser}}</a>
                        </strong>
                        against
                      </span>
                      <strong *ngIf="item.PropertyGuid && (item.ModuleTypeId != 301)">
                        <a href="javascript:void(0);" *ngIf="item.ModuleTypeId == 302 || item.ModuleTypeId == 321" routerLink="/viewproperty/{{item.Slug ? item.Slug : item.PropertyGuid}}" [queryParams]="{prevroute:previousPageRouteName,link:router.url}">{{item.ObjectName}}</a>
                        <a href="javascript:void(0);" *ngIf="item.ModuleTypeId == 305" routerLink="/viewdeproperty/{{item.Slug ? item.Slug : item.PropertyGuid}}" [queryParams]="{prevroute:previousPageRouteName,link:router.url}">{{item.ObjectName}}</a>
                        <a href="javascript:void(0);" *ngIf="item.ModuleTypeId == 324" routerLink="/property-detail/{{item.Slug ? item.Slug : item.PropertyGuid}}" [queryParams]="{prevroute:previousPageRouteName,link:router.url, iscreated:1}">{{item.ObjectName}}</a>
                        <span *ngIf="item.ModuleTypeId == 303">
                          <a href="javascript:void(0);" *ngIf="item.ActionId != 2611" routerLink="/viewproperty/{{item.Slug ? item.Slug : item.PropertyGuid}}" [queryParams]="{prevroute:previousPageRouteName,link:router.url}">{{item.ObjectName}}</a>
                          <a href="javascript:void(0);" *ngIf="item.ActionId == 2611" routerLink="/offer-detail/{{item.PropertyGuid}}" [queryParams]="{prevroute:previousPageRouteName,link:router.url}">{{item.ObjectName}}</a>
                        </span>
                      </strong>
                      <span *ngIf="item.ActionId === 2631 && item.ModuleTypeId==302">
                        to 1031 exchange
                      </span>
                      <span *ngIf="item.ActionId === 2620 && item.ModuleTypeId==302"> documents</span>
                      <strong *ngIf="item.PropertyGuid && item.ModuleTypeId == 301">
                        <strong *ngIf="!item.IsUser && (item.ShortDescription == ' has invited' || item.ShortDescription == ' has added ' || item.ShortDescription == ' created a new user:- ')">
                          <a href="javascript:void(0);" routerLink="/registered-user-details/" [queryParams]="{prevroute:'Activity Log',link:router.url,principal:item.PropertyGuid}">{{item.ObjectName}}</a>
                        </strong>
                        <strong *ngIf="item.IsUser">
                          <a href="javascript:void(0);" routerLink="/employee-details/" [queryParams]="{prevroute:'Activity Log',link:router.url,user:item.PropertyGuid}">{{item.ObjectName}}</a>
                        </strong>
                        <strong *ngIf="!item.IsUser && (item.ActionId === 2616)">
                          <a href="javascript:void(0);" routerLink="/registered-user-details/" [queryParams]="{prevroute:'Activity Log',link:router.url,principal:item.PropertyGuid}">{{item.ObjectName}}</a>
                        </strong>
                      </strong>
                      <strong *ngIf="!item.PropertyGuid && item.ModuleTypeId != 323">
                        {{item.ObjectName}}
                      </strong>
                      <span *ngIf="item.ActionId === 2616 && item.ModuleTypeId==301"> 's profile</span>
                      <span *ngIf="item.ActionId === 2625 && item.ModuleTypeId==301 && item.ShortDescription == ' has invited' || item.ShortDescription == ' has added '"> to the application</span>
                      <strong *ngIf="item.ModuleTypeId == 320">
                        <a href="javascript:void(0);" *ngIf="item.ModuleTypeId == 320 && item.ActionId == 2614" routerLink="/registered-user-details/" [queryParams]="{prevroute:'Activity Log',link:router.url,principal:item.AssociateUserGUID}">{{item.AssociatedUser}}</a>
                        <span style="font-weight: normal" *ngIf="item.ActionId == 2614">
                          <span *ngIf="item.ShortDescription != 'Removed the invited user '"> to the 1031 Exchange </span>
                          <span *ngIf="item.ShortDescription == 'Removed the invited user '"> from the 1031 Exchange </span>
                        </span>
                        <a href="javascript:void(0);" *ngIf="item.ModuleTypeId == 320 && item.ActionId != 2630 && item.ActionId != 2629" routerLink="/dashboard-1031/{{item.PropertyGuid}}" [queryParams]="{prevroute:'Activity Log',link:router.url}">{{item.ObjectName}}</a>
                      </strong>
                      <strong *ngIf="item.ModuleTypeId == 321">
                        <a href="javascript:void(0);" *ngIf="item.ActionId == 2621" routerLink="/bov/request-details/{{item.PropertyGuid}}" [queryParams]="{prevroute:'Activity Log',link:router.url}">BOV Inquiry</a>
                        <a href="javascript:void(0);" *ngIf="item.ActionId == 2622" routerLink="/exchange1031-view/{{item.PropertyGuid}}" [queryParams]="{prevroute:'Activity Log',link:router.url}">1031 Inquiry</a>
                      </strong>
                      <span *ngIf="item.ActionId === 2618 && (item.ModuleTypeId==302 || item.ModuleTypeId==305 ||item.ModuleTypeId==324)"> as Archive</span>
                      <span *ngIf="item.ActionId === 2625 && item.ModuleTypeId==302"> to the portal</span>
                      <span *ngIf="item.ActionId === 2608 && item.ModuleTypeId==302"> favorites</span>
                    </p>
                  </td>
                  <td>
                    <a class="blueone" href="javascript:void(0);" *ngIf="item.HasDetail" (click)="openModalForAuditTrailDetail(template,'commonmodal activitylogmodal',item.AuditTrailLogId)" placement="top" container="body" tooltip="Activity log detail"><i aria-hidden="true" class="icofont icofont icofont-info"></i></a>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr *ngIf="auditTrailList?.length == 0 ">
                  <td colspan="8" class="odd no-data-available">
                    <div class="nodata">
                      <i class="fa fa-exclamation-triangle icon"></i>
                      <p>No Data Available</p>
                    </div>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
        <!--new autit trail ends-->
    </div>
</ng-template>

<ng-template #template class="pull-left">
    <app-audit-trail-details [modalRef]="modalRef" [auditTrailId]="AuditId"></app-audit-trail-details>
</ng-template>
